/**
 * Created by Pankaj singh on 2019-10-15.
 */
export enum GoldenGenieLabels {
    INITIAL_ANIMATION_COMPLETE = "initialAnimationComplete",
    FRAME_MOVE_START = "frameMoveStart",
    MULTIPLIER_HANDOVER_START = "multiplierHandoverStart",
    MULTIPLIER_HANDOVER_END = "multiplierHandoverEnd",
    HANDOVER_COMPLETE = "handoverComplete",
    GOLDEN_GENIE_MUL_REVEAL_START = "GoldenGenieMultiplierRevealStart",
    GOLDEN_GENIE_MUL_REVEAL_END = "GoldenGenieMultiplierRevealEnd",
    GOLDEN_GENIE_SHOOT_FIRE_BALL = "GoldenGenieShootFireBall",
    GOLDEN_GENIE_MULTIPLIER_UPDATE = "GoldenGenieMultiplierUpdate",
    GOLDEN_GENIE_EXPLODE_MULTIPLIER = "GoldenGenieExplodeMultiplier"
}